module.exports = __webpack_public_path__ + "static/le-fc10648665ff204cf76edd33200e4dde.svg";